import React, { useState } from 'react';
import {
  Box,
  Typography,
  Container,
  Grid,
  IconButton,
  Button,
  TextField,
  Alert,
  Fade,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link as MuiLink,
} from '@mui/material';
import { NavLink } from 'react-router-dom';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import InventoryIcon from '@mui/icons-material/Inventory';
import BuildIcon from '@mui/icons-material/Build';
import WorkIcon from '@mui/icons-material/Work';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import BusinessIcon from '@mui/icons-material/Business';
import {
  Email,
  Fax,
  LocationOn,
  Phone,
  Facebook,
  Twitter,
  LinkedIn,
  Instagram,
  YouTube,
} from '@mui/icons-material';

const COLORS = {
  primary: '#123465',
  secondary: '#f9a836',
  lightBg: '#f5faff',
  white: '#fff',
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState(null);

  const socialLinks = [
    { icon: <Facebook />, url: 'https://www.facebook.com/webteledyne', label: 'Facebook' },
    { icon: <Twitter />, url: 'https://twitter.com/Teledyne9', label: 'Twitter' },
    { icon: <LinkedIn />, url: 'https://www.linkedin.com/company/teledyne', label: 'LinkedIn' },
    { icon: <Instagram />, url: 'https://www.instagram.com/teledyne_maroc/', label: 'Instagram' },
    { icon: <YouTube />, url: 'https://www.youtube.com/@nizarbenslimane/', label: 'Youtube' },
  ];

  const aboutLink = [
    { label: 'Qui sommes-nous', path: '/a-propos', icon: <ContactPageIcon /> },
    { label: 'Carrières', path: '/carriere', icon: <WorkHistoryIcon /> },
    { label: 'Contact', path: '/contactus', icon: <BusinessIcon /> },
  ];

  const otherLinks = [
    { label: 'Produits', path: '/produits', icon: <InventoryIcon /> },
    { label: 'Solutions', path: '/solutions', icon: <BuildIcon /> },
    { label: 'Services', path: '/services', icon: <WorkIcon /> },
  ];

  const bottomLinks = [
    { label: 'Catalogues constructeurs', path: '/catalog' },
    { label: 'Téléchargements', path: '/telechargements' },
    { label: 'Solutions logicielles', path: '/produits/logiciels/Description' },
  ];

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (/\S+@\S+\.\S+/.test(email)) {
      setNewsletterStatus({ type: 'success', message: 'Inscription à la newsletter réussie !' });
      setEmail('');
      setTimeout(() => setNewsletterStatus(null), 5000);
    } else {
      setNewsletterStatus({ type: 'error', message: 'Veuillez entrer un email valide.' });
    }
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: COLORS.primary,
        backgroundImage: 'linear-gradient(to top, rgba(0,0,0,0.2), transparent)',
        color: COLORS.white,
        py: 6,
        textAlign: { xs: 'center', md: 'left' },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          {/* Col 1 : Société */}
          

          {/* Col 2 : Nos offres */}
          <Grid item xs={12} sm={6} md={3}>
            <Fade in appear={false} timeout={800}>
              <Box>
                <Typography
                  component="h2"
                  variant="h5"
                  sx={{
                    color: COLORS.secondary,
                    fontWeight: 600,
                    mb: 2,
                    fontSize: { xs: '1.2rem', md: '1.4rem' },
                  }}
                >
                  Nos offres
                </Typography>
                <Divider sx={{ bgcolor: COLORS.secondary, height: 2, mb: 2 }} />
                <List component="div" sx={{ p: 0 }}>
                  {otherLinks.map((link, idx) => (
                    <Fade in appear={false} timeout={800 + idx * 100} key={link.path}>
                      <ListItem
                        component={NavLink}
                        to={link.path}
                        onClick={() => window.scrollTo(0, 0)}
                        sx={{
                          color: COLORS.white,
                          py: 1,
                          borderRadius: 1,
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            color: COLORS.secondary,
                            backgroundColor: `${COLORS.primary}33`,
                            transform: 'scale(1.02)',
                          },
                        }}
                        title={link.label}
                      >
                        <ListItemIcon sx={{ color: 'inherit', minWidth: 32 }}>
                          {link.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={link.label}
                          primaryTypographyProps={{
                            variant: 'body1',
                            fontWeight: 500,
                          }}
                        />
                      </ListItem>
                    </Fade>
                  ))}
                </List>
              </Box>
            </Fade>
          </Grid>

          {/* Col 3 : À propos + Réseaux sociaux */}
          <Grid item xs={12} sm={6} md={3}>
            <Fade in appear={false} timeout={800}>
              <Box>
                <Typography
                  component="h2"
                  variant="h5"
                  sx={{
                    color: COLORS.secondary,
                    fontWeight: 600,
                    mb: 2,
                    fontSize: { xs: '1.2rem', md: '1.4rem' },
                  }}
                >
                  À propos
                </Typography>
                <Divider sx={{ bgcolor: COLORS.secondary, height: 2, mb: 2 }} />
                <List component="div" sx={{ p: 0 }}>
                  {aboutLink.map((link, idx) => (
                    <Fade in appear={false} timeout={800 + idx * 100} key={link.path}>
                      <ListItem
                        component={NavLink}
                        to={link.path}
                        onClick={() => window.scrollTo(0, 0)}
                        sx={{
                          color: COLORS.white,
                          py: 1,
                          borderRadius: 1,
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            color: COLORS.secondary,
                            backgroundColor: `${COLORS.primary}33`,
                            transform: 'scale(1.02)',
                          },
                        }}
                        title={link.label}
                      >
                        <ListItemIcon sx={{ color: 'inherit', minWidth: 32 }}>
                          {link.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={link.label}
                          primaryTypographyProps={{
                            variant: 'body1',
                            fontWeight: 500,
                          }}
                        />
                      </ListItem>
                    </Fade>
                  ))}
                </List>
                
              </Box>
            </Fade>
          </Grid>

          {/* Col 4 : Newsletter */}
          <Grid item xs={12} sm={6} md={3}>
            <Fade in appear={false} timeout={1000}>
              <Box>
                <Typography
                  component="h2"
                  variant="h5"
                  sx={{
                    color: COLORS.secondary,
                    fontWeight: 600,
                    mb: 2,
                    fontSize: { xs: '1.2rem', md: '1.4rem' },
                  }}
                >
                  Newsletter
                </Typography>
                <Divider sx={{ bgcolor: COLORS.secondary, height: 2, mb: 2 }} />
                <Typography variant="body2" sx={{ opacity: 0.9, mb: 2 }}>
                  Rejoignez notre communauté pour recevoir les dernières mises à jour.
                </Typography>
                {newsletterStatus && (
                  <Fade in timeout={500}>
                    <Alert
                      severity={newsletterStatus.type}
                      onClose={() => setNewsletterStatus(null)}
                      sx={{ mb: 2 }}
                    >
                      {newsletterStatus.message}
                    </Alert>
                  </Fade>
                )}
                <Box
                  component="form"
                  noValidate
                  onSubmit={handleNewsletterSubmit}
                  sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
                >
                  <TextField
                    variant="outlined"
                    placeholder="Votre email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{
                      bgcolor: COLORS.white,
                      borderRadius: 1,
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: COLORS.secondary },
                        '&:hover fieldset': { borderColor: COLORS.secondary },
                        '&.Mui-focused fieldset': { borderColor: COLORS.secondary },
                      },
                      '& .MuiInputBase-input': { color: COLORS.primary },
                    }}
                  />
                  <Button
                    type="submit"
                    sx={{
                      backgroundColor: COLORS.secondary,
                      color: COLORS.white,
                      fontWeight: 'bold',
                      borderRadius: 2,
                      py: 1.2,
                      textTransform: 'none',
                      '&:hover': {
                        backgroundColor: '#e59630',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      },
                    }}
                  >
                    S&apos;inscrire
                  </Button>
                </Box>
              </Box>
            </Fade>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
  <Fade in appear={false} timeout={600}>
    <Box>
      <Typography
        component="h2"
                  variant="h5"
        sx={{
          color: COLORS.secondary,
          fontWeight: 600,
          mb: 2,
          fontSize: { xs: "1.2rem", md: "1.4rem" },
        }}
      >
        Contact
      </Typography>

      <Divider sx={{ bgcolor: COLORS.secondary, height: 2, mb: 2 }} />

      {/* Téléphone */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 1.5,
          opacity: 0.9,
          gap: 1,
        }}
      >
        <Phone fontSize="small" sx={{ color: COLORS.secondary }} />
        <Typography variant="body2">+212 522 307 664</Typography>
      </Box>

      {/* Téléphone 2 (SAV / Support) */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 1.5,
          opacity: 0.9,
          gap: 1,
        }}
      >
        <Phone fontSize="small" sx={{ color: COLORS.secondary }} />
        <Typography variant="body2">+212 522 307 668</Typography>
      </Box>

      {/* Fax */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 1.5,
          opacity: 0.9,
          gap: 1,
        }}
      >
        <Fax fontSize="small" sx={{ color: COLORS.secondary }} />
        <Typography variant="body2">+212 522 307 532</Typography>
      </Box>

      {/* Email */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 1.5,
          opacity: 0.9,
          gap: 1,
        }}
      >
        <Email fontSize="small" sx={{ color: COLORS.secondary }} />
        <Typography variant="body2">contact@teledyne.ma</Typography>
      </Box>

      {/* Adresse */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          opacity: 0.9,
          gap: 1,
        }}
      >
        <LocationOn fontSize="small" sx={{ color: COLORS.secondary, mt: 0.4 }} />
        <Typography variant="body2">
          2, rue Abdelouhab Azzakkak  
          <br />
          Roches Noires – Casablanca 20310  
          <br />
          Maroc
        </Typography>
      </Box>
    </Box>
  </Fade>

  {/* Séparateur */}
  <Divider sx={{ bgcolor: COLORS.secondary, height: 2, mt: 3, mb: 2 }} />

  {/* Réseaux sociaux */}
  <Box
    sx={{
      display: "flex",
      justifyContent: { xs: "center", md: "flex-start" },
    }}
  >
    {socialLinks.map((social, index) => (
      <IconButton
        key={index}
        href={social.url}
        target="_blank"
        rel="noreferrer"
        aria-label={social.label}
        sx={{
          color: COLORS.secondary,
          fontSize: 30,
          mx: 0.5,
          "&:hover": { color: COLORS.white },
        }}
      >
        {social.icon}
      </IconButton>
    ))}
  </Box>
</Grid>

        </Grid>

        {/* Bas de footer */}
        <Box
          sx={{
            mt: 4,
            pt: 2,
            borderTop: `1px solid ${COLORS.white}99`,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {new Date().getFullYear()} Teledyne. Tous droits réservés.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              flexWrap: 'wrap',
              justifyContent: { xs: 'center', md: 'flex-end' },
            }}
          >
            {bottomLinks.map((item) => (
              <MuiLink
                key={item.label}
                component={NavLink}
                to={item.path}
                onClick={() => window.scrollTo(0, 0)}
                sx={{
                  color: COLORS.white,
                  textDecoration: 'none',
                  fontSize: '0.8rem',
                  transition: 'color 0.3s ease',
                  '&:hover': {
                    color: COLORS.secondary,
                  },
                }}
              >
                {item.label}
              </MuiLink>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
